import { all, call, put, fork, takeEvery, select } from 'redux-saga/effects';
import {
    fetchMembersSuccess,
    showMemberMessage,
    onSaveMemberSuccess,
    onDeleteMemberSuccess,
    addFavouriteMemberSuccess,
} from 'actions/member';
import {
    ON_SAVE_MEMBER,
    FETCH_ALL_MEMBER,
    ON_DELETE_MEMBER,
    ADD_FAVOURITE_MEMBER,
} from 'constants/ActionTypes';
import { fetchDataRequest, addOrUpdateDataRequest, updateDataRequest, deleteDataRequest  } from 'services/ApiService';
import { apiErrorMessageFormatter } from 'services/errorService';
import { ORGID_PATH_PARAM } from 'constants/api';

const currentOrg = (state) => state.orgs.selectedOrg;
const getMemberList = (state) => state.members.allMember;

export function* fetchMembers() {
    try {
        const selectedOrg = yield select(currentOrg);
        const fetchedMembers = yield call(
            fetchDataRequest,
            'members',
            [ORGID_PATH_PARAM],
            [selectedOrg ?.id]
        ) || [];
        yield put(fetchMembersSuccess(fetchedMembers));
    } catch (error) {
        yield put(showMemberMessage(apiErrorMessageFormatter(error)));
    }
}

export function* deleteMember({ payload }) {
    try {
        // payload should be the memberId
        const selectedOrg = yield select(currentOrg);
        yield call(
            deleteDataRequest,
            'deleteMember',
            'Deleting member '.concat(payload),
            [ORGID_PATH_PARAM, 'memberId'],
            [selectedOrg ?.id, payload]
        ) || [];
        yield put(onDeleteMemberSuccess(payload)); // just dispatch the id as the reducer will remove from the item from the list
    } catch (error) {
        yield put(showMemberMessage(apiErrorMessageFormatter(error)));
    }
}

export function* saveMember({ payload }) {
    try {
        const selectedOrg = yield select(currentOrg);
        const allMembers = yield select(getMemberList);
        let finalPayload = { ...payload };
        // check the orgid of the payload - it will be empty for a new payload - populate from the selectedOrg - otherwise leave it as is
        if (payload ?.orgid === '') {
            finalPayload = { ...payload, orgid: selectedOrg ?.id };
        }
        const savedMember = yield call(
            addOrUpdateDataRequest,
            allMembers,
            finalPayload,
            'addMember',
            'updateMember',
            [ORGID_PATH_PARAM],
            [selectedOrg.id]);
        yield put(onSaveMemberSuccess(savedMember));
    } catch (error) {
        yield put(showMemberMessage(apiErrorMessageFormatter(error)));
    }
}

/**
 * This is when the user selects the star on the list page - update the starred attribute of the entity
 * @param {*} param0 
 */
export function* addFavouriteMember({ payload }) {
    try {
        const allMembers = yield select(getMemberList);
        const selectedOrg = yield select(currentOrg);
        const filtered = allMembers.filter((entry) => entry ?.id === payload ?.id);

        if (filtered ?.length > 0) {
            const entry = filtered[0];
            const updatedMember = {
                ...entry,
                starred: !payload.starred
            };
            const auditMsg = 'Updating starred setting to '.concat(updatedMember ?.starred).concat(' for member ').concat(updatedMember ?.id);
            yield call(
                updateDataRequest,
                updatedMember,
                'updateMember',
                auditMsg,
                [ORGID_PATH_PARAM],
                [selectedOrg.id],
            );
            // now just pass on the original payload as the reducer will filter the list as per the state of the selection
            yield put(addFavouriteMemberSuccess(payload));
        }
    } catch (error) {
        yield put(showMemberMessage(error.messages));
    }
}

export function* fetchMembersSaga() {
    yield takeEvery(FETCH_ALL_MEMBER, fetchMembers);
}

export function* saveMemberSaga() {
    yield takeEvery(ON_SAVE_MEMBER, saveMember);
}

export function* deleteMemberSaga() {
    yield takeEvery(ON_DELETE_MEMBER, deleteMember);
}

export function* addFavouriteMemberSaga() {
    yield takeEvery(ADD_FAVOURITE_MEMBER, addFavouriteMember);
}

export default function* rootSaga() {
    yield all([
        fork(fetchMembersSaga),
        fork(saveMemberSaga),
        fork(deleteMemberSaga),
        fork(addFavouriteMemberSaga),
    ]);
}


// WEBPACK FOOTER //
// ./sagas/member.js